module.exports = __webpack_public_path__ + "img/T1A_rc_18.89262b37.png";